import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';
import { CustomerDataService } from 'src/app/facilityOperations/facOps-customer/customer-data.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { DataService } from 'src/app/facilityOperations/facOps-dashboard/data.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { twoWayService } from 'src/app/services/operations/two-way-text.service';
import { ISendSmsResponse, ISendSMSLogsResponse } from '../interface2';
import { CustomerService } from 'src/app/services/operations/customer.service';
import { IDashboardDetails } from '../models/CustomerModel';
import { GeneralService } from 'src/app/services/general.service';
import { Observable } from 'rxjs';
import { LetterAndNoticesService } from 'src/app/services/letterAndNotices.service';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { ELOV_TransactionTypes, ETransactionTypes } from '../enum';
import { DatePipe } from '@angular/common';
import{interval} from 'rxjs';

@Component({
    selector: 'app-sms-box',
    templateUrl: './sms-box.component.html',
    styleUrls: ['./sms-box.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class SmsBoxComponent implements OnInit {

  @Output() closeChat = new EventEmitter<void>();
  @Input() tenantContactInfo;
  @Input() tLeaseNo;
  @Input() facID;
  facilityID;
  stopDraging : boolean = false;
  minimize_icon = true;
  maximize_icon = false;
  smstext = '';
  logs;
  tenantPhone;
  tenantName;
  SysDate = new Date();
  smsCount;
  filteredLogs;
  customerDashboardDetails;
  countryCode;
  fullphonenumber;
  noMessages = 'No Messages to Display';
  tenantId;
  listOfValues;
  tenantleaseNumber;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  @ViewChild('scrollMe', { static: true }) private myScrollContainer: ElementRef;
  @Input() contactInfoDetails;
  @Input() countryCodeContactInfo;
  lettertypelist: any;
  LetterTemplateDetails: any;
  selectedLetterType: any;
  leaseNumber: any;
  reservationNumber: any;
  inquiryNumber: any;
  isSMSUnchecked = false;
  isCellPhoneAvailable: boolean = false;
  transactionTypeId: any;
  LeaseNo: any;
  reservatinNo: any;
  inquiryNo: any;

  constructor(
    private modalService: BsModalService,
    private twoWayService: twoWayService,
    private toastr: ToastrService,
    private data: DataService,
    private customerService: CustomerService,
    private userSessionService: UserSessionService,
    private customerDataService: CustomerDataService,
    private generalService: GeneralService,
    private letterAndNoticesService: LetterAndNoticesService,
    private facOpsDataService: FacOpsDataService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    if (this.userSessionService.userSessionData.UserGroup.CallCenterGroup == true) {
      this.facilityID = this.facID;
    } else {
      this.facilityID = this.userSessionService.userSessionData.LastAccessedStoreId;
    }
    this.isSMSUnchecked = this.facOpsDataService.isSMSUnchecked;
    if (this.customerDataService.CustomerInfoList) {
    var temp = this.customerDataService.CustomerInfoList.Phone;
    this.tenantPhone = temp;
    this.tenantName = this.customerDataService.CustomerInfoList.TenantName;
    this.countryCode = this.customerDataService.CustomerInfoList.CountryCode;
    this.fullphonenumber = '+' + this.countryCode + this.tenantPhone;
    this.tenantId = this.customerDataService.CustomerInfoList.TenantId;
    this.tenantleaseNumber = this.data.custimerInfoStorage.leaseNo;
    //this.getSmsLogs();
    } else if (this.tenantContactInfo) {
      this.getListOfValues();
      this.tenantPhone = this.tenantContactInfo.CellPhoneNumber;
      this.countryCode = this.countryCodeContactInfo ? this.countryCodeContactInfo : '1';
      this.fullphonenumber = '+' + this.countryCode + this.tenantPhone;
      this.tenantId = this.tenantContactInfo.TenantId;
      this.tenantleaseNumber = this.tLeaseNo? this.tLeaseNo : null;
      //this.getSmsLogs();
    } else if(this.contactInfoDetails){
      var temp = this.contactInfoDetails.PhoneNumber;
    this.tenantPhone = temp;
    this.tenantName = this.contactInfoDetails.TenantName;
    this.countryCode = this.contactInfoDetails.CountryCode;
    this.fullphonenumber = '+' + "1" + this.tenantPhone;
    this.tenantId = this.contactInfoDetails.TenantId;
    this.tenantleaseNumber = this.contactInfoDetails.LeaseNo;
    //this.getSmsLogs();
    }
    this.isCellPhoneAvailable =!!this.customerDataService.CustomerInfoList?.Phone || !!this.contactInfoDetails?.PhoneNumber || (!!this.tenantContactInfo && !!this.tenantContactInfo.CellPhoneNumber);
    this.selectedLetterType = null;
    this.getSmsLogs();
    this.getLettersAndNoticesTemplateList();
    const source = interval(2 * 60 * 1000);
    source.subscribe(val => this.getSmsLogs());
  }

  minimize() {
    document.querySelector('.chat-Box-container').classList.toggle('minimize');
    this.stopDraging = true;
    this.minimize_icon = false;
    this.maximize_icon = true;
  }
  maximize() {
    document.querySelector('.chat-Box-container').classList.toggle('minimize');
    this.stopDraging = false;
    this.minimize_icon = true;
    this.maximize_icon = false;
  }

  getSmsLogs() {
    const obj = {
      FacilityId: this.facilityID,
      TenantId: this.tenantId,
      FilterText: 'all',
    };
    this.twoWayService.getSmsLogs(obj).subscribe((response: ISendSMSLogsResponse) => {
      this.logs = response;
      this.logs.forEach(element => {
        element.FacilityDateTime = element.FacilityDateTime?.replace('Z', '');
      });
      this.filteredLogs = this.logs;
      if (this.filteredLogs != undefined) {
        if (this.filteredLogs.length > 0) {
          this.noMessages = '';
        }
      }
      this.scrollToBottom();

      // use the currently selected unit's own Lease Number (Customer section) or Reservation/Inquiry Number (Prospect section) instead of SMS history, which may reflect an unrelated older transaction
      this.LeaseNo = this.tenantleaseNumber || null;
      this.reservatinNo = this.LeaseNo ? null : (this.facOpsDataService?.reservationNumber || (this.facOpsDataService?.ProspectItemType == "RESERVATION" ? this.facOpsDataService?.confirmationNumberForMessege : null) || null);
      this.inquiryNo = this.LeaseNo ? null : (this.facOpsDataService?.inquiryNumber || (this.facOpsDataService?.ProspectItemType == "INQUIRY" ? this.facOpsDataService?.confirmationNumberForMessege : null) || null);
      this.transactionTypeId = this.LeaseNo ? ETransactionTypes.Move_In : this.reservatinNo ? ETransactionTypes.Reservation : this.inquiryNo ? ETransactionTypes.Inquiry : null;
    });
  }

  sendTheSms() {
    if (this.smstext === undefined || this.smstext.trim() === '' || this.smstext === null) {
      this.toastr.error('Text cannot be blank', 'Failure', this.toasterConfig);
    } else {
      let phoneNumberArr = [];
      phoneNumberArr.push(this.fullphonenumber);
      var Messages = [];
      let singleMessage = {
        FromPhoneNumber: null,
        ToPhoneNumberList: phoneNumberArr,  //give tenant number
        Message: this.smstext,
        TenantPhoneNumber: null,
        MessageStatus: 'sent',
        ErrorCode: null,
      };
      Messages.push(singleMessage);

      // tenantleaseNumber reflects the tenant's actual current lease; facOpsDataService can retain stale reservation/inquiry values from unrelated flows
      let leaseNo  = this.tenantleaseNumber || this.facOpsDataService?.LeaseNumber || this.facOpsDataService?.unitList?.filter(x => x.ProcessType === "Rented Unit").map(x => x.ConfirmationNumber).shift() || null;
      let reservatinNo = leaseNo ? null : (this.facOpsDataService?.reservationNumber || (this.facOpsDataService.ProspectItemType == "RESERVATION"? this.facOpsDataService.confirmationNumberForMessege : null) || this.facOpsDataService?.unitList?.filter(x => x.ProcessType === "Reserved Unit").map(x => x.ConfirmationNumber).shift() || null);
      let inquiryNo  = leaseNo ? null : (this.facOpsDataService?.inquiryNumber || (this.facOpsDataService.ProspectItemType == "INQUIRY"? this.facOpsDataService.confirmationNumberForMessege : null) || this.facOpsDataService?.unitList?.filter(x => x.ProcessType === "Inquiry Unit").map(x => x.ConfirmationNumber).shift() || null);

      if(leaseNo == null && reservatinNo == null && inquiryNo == null){
        leaseNo = this.LeaseNo;
        reservatinNo = this.reservatinNo;
        inquiryNo = this.inquiryNo;
      }

      const Fobj = {
        LocationId: this.facilityID,
        AccountID: null,
        Token: null,
        ServiceId: 0,
        LeaseNumber: leaseNo,
        FacilityId: this.facilityID,
        ReservationNumber: reservatinNo,
        ReservationFacilityId: null,
        InquiryNumber: inquiryNo,
        InquiryFacilityId: null,
        TenantId: this.tenantId,
        TransactionTypeId: leaseNo? ETransactionTypes.Move_In : reservatinNo? ETransactionTypes.Reservation : inquiryNo? ETransactionTypes.Inquiry : this.transactionTypeId? this.transactionTypeId : null,
        SentSuccessfully: true,
        SMSCampaignId: null,
        SMSList: Messages,
        ProspectItemType: this.facOpsDataService.ProspectItemType,
        ConfirmationNumber: this.facOpsDataService.confirmationNumberForMessege,
      };
      this.twoWayService.SendSms(Fobj).subscribe((response: ISendSmsResponse) => {
      if (response.Success === true) {
        this.smstext = '';
        this.selectedLetterType = null;
        this.toastr.success('SMS Sent Successfully!', 'Success', this.toasterConfig);
        this.getSmsLogs();
        } else {
          this.smstext = '';
          this.selectedLetterType = null;
          this.toastr.error('Failed to Send SMS', 'Failure', this.toasterConfig);
        }
      });
    }
  }
  scrollToBottom(){
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
  }

  getListOfValues() {
    if (this.userSessionService.lovList && this.userSessionService.lovList.length) {
      this.setListOfValuesBasedOnType();
    } else {
      this.generalService.getAllListOfValues().subscribe((response: any) => {
        if (response.length) {
          this.userSessionService.lovList = response;
          this.setListOfValuesBasedOnType();
        }
      });
    }
  }

  setListOfValuesBasedOnType() {
    this.listOfValues = this.userSessionService.getLovListForType(12);
    this.getTenantNameDisplayOrder();
  }

   getTenantNameDisplayOrder() {
    this.generalService.GetTenantNameDisplayOrder(this.facilityID).subscribe(response => {
      if (response !== null) {
        let nameFormatObj  = this.listOfValues.find(l => l.Id == response);
        if (nameFormatObj) {
          let nameFormat = nameFormatObj.Name;
          let firstName = !this.tenantContactInfo.FirstName ? "" : this.tenantContactInfo.FirstName;
          let midName = !this.tenantContactInfo.MiddleName ? "" : this.tenantContactInfo.MiddleName;
          let lastName = !this.tenantContactInfo.LastName ? "" : this.tenantContactInfo.LastName;
          this.tenantName = nameFormat.replace("<Last Name>", lastName);
          this.tenantName = this.tenantName.replace("<First Name>", firstName);
          this.tenantName = this.tenantName.replace("<Middle Name>", midName);
        }
      }
    });
  }

  getLettersAndNoticesTemplateList() {
    this.letterAndNoticesService.GetLettersAndNoticesTemplateListByTypeIdAndFacilityId(202,this.facID).subscribe((response: any) => {
      this.lettertypelist = response;
    });
  }

  onLetterTypeChange(event){
    var letterandnoticeid = parseInt(event);
    this.selectedLetterType = this.lettertypelist.find(o => o.Id === letterandnoticeid).Id;
    this.getLettersAndNoticesByPassingID(this.selectedLetterType);
  }

  getLettersAndNoticesByPassingID(typeId) {
    this.letterAndNoticesService.getLettersAndNoticesByIdForOp(typeId).subscribe((response: any) => {
      this.LetterTemplateDetails = response;
      this.smstext = this.LetterTemplateDetails.SMSContents;
    });
  }
}
